import React from "react";
import PropTypes from "prop-types";
import {
  getBuyerTypeName,
  getPromotionColor,
  getNameVenueORExtra,
  messageResultCode,
  validationModes,
  getBuyerTypeColor,
} from "../../utils/verifier.utils";

const TicketInfoValidation = ({ validation }) => {
  console.log("validation", validation);
  return (
    <div className="result">
      {validation.map((item, index) => (
        <div
          key={index}
          style={
            item.buyerTypeId &&
            item.resultCode === 200 &&
            getBuyerTypeColor(item.buyerTypeId)
              ? { backgroundColor: getBuyerTypeColor(item.buyerTypeId) }
              : {}
          }
          className={
            item.resultCode === 200 || item.resultCode === 203
              ? "bg-success media"
              : "bg-danger media"
          }
        >
          {item.validationMode === validationModes.override ? (
            <div className="media-left">
              <div>
                <span className="icon-own-forced-ticket"> </span>
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="media-body">
            <h4 className="media-heading">
              {item.resultCode === 200
                ? item.buyerTypeId && getBuyerTypeName(item.buyerTypeId)
                : messageResultCode(item.resultCode)}
            </h4>
            <p>{getNameVenueORExtra(item)}</p>
          </div>
          {item.promotionId ? (
            <div className="media-right promo">
              <div>
                <span
                  style={
                    getPromotionColor(item.promotionId)
                      ? { color: getPromotionColor(item.promotionId) }
                      : {}
                  }
                  className="icon-own-star"
                >
                  {" "}
                </span>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      ))}
    </div>
  );
};

TicketInfoValidation.PropTypes = {
  validation: PropTypes.array.isRequired,
};

export default TicketInfoValidation;
